import { render, staticRenderFns } from "./AddDisabledDateForm.vue?vue&type=template&id=8c1788e2"
import script from "./AddDisabledDateForm.vue?vue&type=script&lang=js"
export * from "./AddDisabledDateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports